import React, { useState } from "react";
import { useCardStore } from "../../../stores/cardStore";
import BingoCard from "../../BingoCard/BingoCard";
import "./SelectableCard.css"
import CustomButton from "../../Shared/CustomButton/CustomButton";
import { useChipStore } from "../../../stores/chipStore";
import { useToastifyStore } from "../../../stores/toastifyStore";
import { ToastType } from "../../../constants/toast";



type SelectableCardProps = {
  cardId: number,
  numbers: (number | null)[],
  disabled?: boolean
};

const initialChip = { index: -1, price: 0, path: "" };

const SelectableCard = React.memo(function SelectableCard({ cardId, numbers, disabled = false }: SelectableCardProps) {
  const [chip, setChip] = useState(initialChip);
  const selectedChip = useChipStore(c => c.selectedChip);

  const selectedCards = useCardStore((s) => s.selectedCardandChip);

  const selectCard = useCardStore((s) => s.selectCard);
  const deselectCard = useCardStore((s) => s.deselectCard);

  const addToast = useToastifyStore(t => t.addToast);

  function HandleSelectedButton() {
    if (!selectedChip.price) {
      addToast({
        content: "يجب عليك اختيار شريحة",
        type: ToastType.warning
      })
    }
    else if (chip.index !== -1) {
      setChip(initialChip)
      deselectCard(cardId);
    }
    else if (chip.index === -1 && selectedCards.length < 5) {
      setChip(selectedChip);
      selectCard(cardId, numbers, selectedChip.price);
    }
  }

  return (
    <CustomButton
      className="selectable-card"
      onClick={HandleSelectedButton}
      disabled={disabled}
    >
      {chip.index !== -1 ? <Selected path={chip.path} /> : <div></div>}
      <BingoCard cardId={cardId} numbers={numbers} />
    </CustomButton>
  );
})

export default SelectableCard;


function Selected({ path }: { path: string }) {
  return (
    <div className={"selected-card-div"}>
      <div className="selected-card-chip-con">
        <img className="selected-card-chip" src={path} alt="chip" />
      </div>
    </div>
  )
}